"use strict";

angular.module('PatientApp').directive('compile', function ($compile) {
  return {
    restrict: 'A',
    link: function link($scope, element, attrs) {
      var compileHtml = function compileHtml() {
        var value = $scope.$eval(attrs.compile);
        element.html(value);
        $compile(element.contents())($scope);
      };

      compileHtml();
      $scope.$watch(attrs.compile, compileHtml);
    }
  };
});